<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="plus"
      text="Dodaj novi"
      type="default"
      (onClick)="onAddClick()">
    </dx-button>
    
    <dx-button
      icon="edit"
      text="Izmijeni"
      type="default"
      [disabled]="!selectedOpi"
      (onClick)="onEditClick()">
    </dx-button>
    
    <!-- <dx-button
      icon="trash"
      text="Delete"
      type="danger"
      [disabled]="!selectedOpi"
      (onClick)="onDeleteClick()">
    </dx-button> -->
    
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="loadOpisi()">
    </dx-button>
  </div>

  <dx-data-grid
    #opisiGrid
    id="opisiGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true"
    (onRowClick)="onRowClick($event)">
    
    <dxi-column dataField="id" caption="ID" [width]="80" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="opis" caption="Opis" [minWidth]="300"></dxi-column>
    <!-- Add other columns based on your Opi model -->
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Dodaj Novi Opis"
  [(visible)]="isCreatePopupVisible"
  (onHiding)="onCreatePopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="opiForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="opis"
          placeholder="Unesite opis"
          [isValid]="!opiForm.get('opis')?.errors"
          validationMessage="Opis je obavezan">
        </dx-text-box>
        
        <!-- Add other form fields as needed -->
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Kreiraj"
          type="default"
          (onClick)="createOpi()"
          [disabled]="!opiForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<!-- Edit Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Izmijeni Opis"
  [(visible)]="isEditPopupVisible"
  (onHiding)="onEditPopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="opiForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="opis"
          placeholder="Unesite opis"
          [isValid]="!opiForm.get('opis')?.errors"
          validationMessage="Opis je obavezan">
        </dx-text-box>
        
        <!-- Add other form fields as needed -->
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Izmijeni"
          type="default"
          (onClick)="updateOpi()"
          [disabled]="!opiForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isEditPopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>